export const RESET_HOURS = [1, 6, 12, 48, 72] as const;
export type ResetHours = (typeof RESET_HOURS)[number];

export const MASK = "∗∗∗∗∗∗∗∗∗∗∗∗∗∗∗∗∗∗∗∗∗∗∗∗∗∗∗∗∗∗∗∗";
